import { useState } from "react";
import { toast } from "react-toastify";
import { Card, CardBody, Col, Input, Row } from "reactstrap";

import MultipleFileRendererV2 from "@/components/Common/MultipleFileRendererV2";

import { useGetFilesDoctorEnrollmentsQuery } from "@/api/Endpoints/Globo/Transactions/DoctorEnrollment/DoctorEnrollments";

const FileHistory = ({ doctorEnrollmentId }) => {

  const [searchTerm, setSearchTerm] = useState("");
  const [keyword, setKeyword] = useState("");

  const {
    data,
    refetch: refetchFiles,
    isFetching,
  } = useGetFilesDoctorEnrollmentsQuery(
    {
      doctorEnrollmentId: doctorEnrollmentId,
      keyword: keyword,
    },
    {
      skip: !doctorEnrollmentId,
      refetchOnMountOrArgChange: true,
    },
  );

  const files = isFetching ? [] : data?.returnData || [];

  const handleChangeSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleKeySearchDown = (e) => {
    if (e.key === "Enter") {
      setKeyword(searchTerm);
    }

    if (e.key === "Escape") {
      setSearchTerm("");
      setKeyword("");
    }
  };

  const hasNoFiles = !files || files.length === 0;

  const hasNoSearchResults = files.length === 0 && searchTerm.trim() !== "";


  return (
    <>

      <Card>
        <CardBody>
          <div style={{ minHeight: "60vh" }}>
            <Row>
              <Col sm={5}>
                <div className="search-box mb-4 mt-auto d-inline-block w-100">
                  <Input
                    className="form-control bg-light border-light"
                    placeholder={"Search here..."}
                    type="text"
                    value={searchTerm}
                    onChange={handleChangeSearch}
                    onKeyDown={handleKeySearchDown}
                  />
                  <i
                    className="bx bx-search-alt search-icon"
                    style={{ cursor: "pointer" }}
                    onClick={() => setKeyword(searchTerm)} // optional click search
                  ></i>
                </div>
              </Col>
            </Row>

            {!isFetching && hasNoFiles ? (
              <div className="text-center py-5">
                <h5 className="fs-15 mt-2">{searchTerm ? "No Files Found" : "No Files Yet"}</h5>
                <p className="text-muted fs-13">
                  {searchTerm ? `No files match your search "${searchTerm}"` : "There are no files uploaded for this patient."}
                </p>

                {hasNoSearchResults && (
                  <button
                    className="btn btn-sm btn-soft-primary mt-2"
                    onClick={() => {
                      setSearchTerm("");
                      setKeyword("");
                    }}>
                    Clear Search
                  </button>
                )}
              </div>
            ) : (
              <MultipleFileRendererV2
               xl={6}
                files={files}
                onDeleteSuccess={() => {
                  toast("File was successfully deleted.", {
                    position: "top-right",
                    hideProgressBar: false,
                    closeOnClick: true,
                    className: `bg-danger text-white`,
                  });
                  refetchFiles();
                }}
              />
            )}
          </div>
        </CardBody>
      </Card>
    </>
  );
};

export default FileHistory;
